export const WEBSERVICE_IP = 'https://microservices.contreras.website/gday/';

